import React, {ReactNode, useEffect} from 'react';
import styles from './DropdownMenu.module.scss';
import {ProfileDropdowns} from "../../pages/profile";

interface DropdownMenuProps {
    iconPath?: string;
    label: string;
    preOpened?: boolean;
    preOpenedDropdown?: ProfileDropdowns;
    children?: ReactNode;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({iconPath, label, preOpened = false, preOpenedDropdown = ProfileDropdowns.NONE, children}) => {
    const [isOpened, setIsOpened] = React.useState(preOpened);

    function handleOpenCloseClick() {
        setIsOpened(!isOpened);
    }

    useEffect(() => {
        setIsOpened(preOpened);
    }, [preOpenedDropdown]);

    return (
        <div style={{width: "482px", justifyContent: "center", alignItems: "center", display: "flex", flexDirection: "column"}}>
            <div className={styles.dropdownMenuContainer} onClick={handleOpenCloseClick}>
                <div className={styles.dropdownMenuPanel}>
                    <div className={styles.div}>{label}</div>
                </div>
                <div className={styles.dropdownMenuIcons}>
                    {!isOpened &&
                        <svg className={styles.dropdownMenuIconSecondary} width="22" height="13" viewBox="0 0 22 13" onClick={handleOpenCloseClick}
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.5L11 11.5L21 1.5" stroke="#757373" strokeWidth="5"
                                  strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        ||
                        <svg className={styles.dropdownMenuIconSecondary} width="22" height="13" viewBox="0 0 22 13" onClick={handleOpenCloseClick}
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.9987 11.8116L11.0833 1.72764L0.999368 11.643" stroke="#8AD2FF"
                                  strokeWidth="5"
                                  strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>}
                </div>
                {iconPath && <img className={styles.dropdownMenuProfileImage} src={iconPath} alt="icon"/>}
            </div>
            {isOpened &&
                children
            }
        </div>
    );
}

export default DropdownMenu;
